import React, { useState } from 'react'
import { Flex, Input, Modal, Typography } from 'antd'
import { useUnit } from 'effector-react'
import {
  $blockTarget,
  blockGatewayFx,
  closeBlockModal,
  submitGatewayBlock,
} from './model'

const { Text } = Typography

const REASON_MAX_LENGTH = 255
const COUNT_OFFSET = 24

type Props = {
  clientId: string
}

export const BlockReasonModal: React.FC<Props> = ({ clientId }) => {
  const [gateway, pending] = useUnit([$blockTarget, blockGatewayFx.pending])
  const [reason, setReason] = useState('')

  const submit = () => {
    if (!gateway) return

    submitGatewayBlock({
      clientId,
      gatewayId: gateway.gatewayId,
      isBlocked: true,
      reason,
    })
  }

  return (
    <Modal
      title="Block gateway"
      open={Boolean(gateway)}
      onCancel={() => closeBlockModal()}
      onOk={submit}
      okText="Block"
      cancelText="Cancel"
      okButtonProps={{
        danger: true,
        disabled: !reason.trim(),
        loading: pending,
      }}
      cancelButtonProps={{ disabled: pending }}
      afterClose={() => setReason('')}
      destroyOnHidden
    >
      {/* bottom margin reserves space for the absolutely positioned showCount */}
      <Flex vertical gap={12} style={{ marginBottom: COUNT_OFFSET }}>
        <Text type="secondary">
          {gateway?.internalName} · ID {gateway?.gatewayId}
        </Text>

        <Input.TextArea
          rows={3}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          placeholder="Reason"
          maxLength={REASON_MAX_LENGTH}
          showCount
          autoFocus
        />
      </Flex>
    </Modal>
  )
}
